import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateWithTimeFormatter',
  standalone: true
})
export class DateWithTimeFormatterPipe implements PipeTransform {

  transform(dateString: string): string {
    if (!dateString) return '';
    const date = moment.utc(dateString).local(); // Convert to local time
    return date.local().format('DD MMM YYYY hh:mm A');
  }
}
